import React, { useState, useEffect, useRef } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '../icons/MenuIcon';
import CloseIcon from '../icons/CloseIcon';
import SearchIcon from '../icons/SearchIcon';
import clsx from "clsx";
import IconBtn from "./IconBtn";
import Grid from "@material-ui/core/Grid";
import translate from '../other/translate.json';
import Link from '@material-ui/core/Link';
import Autorization from "./Autorization";
import utils from '../other/utils';
import axios from 'axios';
import config from '../other/config';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomAutocomplete from './CustomsearchAutocomplete';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { Tooltip } from '@material-ui/core';
const { serverAPI } = config;
const { compareApps, getItemFromStorage } = utils
const filterOptions = createFilterOptions({
	limit: 5,
	stringify: option => option.searchValue,
});
// import Avatar from '@material-ui/core/Avatar';
// import SearchIcon from '@material-ui/icons/Search';
// import Badge from '@material-ui/core/Badge';
// import MailIcon from '@material-ui/icons/Mail';
// import NotificationsIcon from '@material-ui/icons/Notifications';

const drawerWidth = 334;
const drawerWidthMin = 96;

export default function TopBar(props) {
	const { usname, setUsname, isAuth, setIsAuth, kloUser, _kloUser } = props

	const [language, setLanguage] = useState(localStorage.getItem('language') || 'Ru')
	const classes = useStyles();
	const [searchFocus, setSearchFocus] = useState(false);
	const [badgeBasket, setBadgeBasket] = useState(false);
	const [searchAction, setSearchAction] = useState(true);
	const [searchText, setSearchText] = useState('');
	const [searchPhrases, _searchPhrases] = useState([]);
	let searchParams = new URLSearchParams(window.location.search);


	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			const result = await axios.get(`${serverAPI}/getSearchPhrases`);
			if (!didCancel) {
				if (result && result.data) {
					_searchPhrases(result.data)
					if (!!props._searchPhrases) {
						props._searchPhrases(result.data)
					}
				}
			}
		}

		fetchData();

		return () => {
			didCancel = true;
		};
	}, []);

	function searchClick(event, val) {
		setSearchText('')
		val = validateVal(val);
		window.location.href = `/search?q=${encodeURIComponent(val.replace(/%/g, "~percent~"))}`
		setSearchAction(!searchAction)
	}

	const validateVal =(val) => {
		let hasFindValue = searchPhrases.map(el => el.searchValue).includes(val)
		if (!hasFindValue && typeof val === 'string') {
			val = val.replace(/'|"|;/gmi,'')
		}
		val = val.replace(/ALTER|CREATE|DELETE|DROP|EXEC(UTE){0,1}|INSERT( +INTO){0,1}|MERGE|SELECT|UPDATE|UNION( +ALL){0,1}|;/gmi,'')
		if (val.length > 1000) {
			val = val.slice(0,999)
		}
		return val
	}



	function handleKeyDown(val) {
		// if (event.key === 'Enter' && val !== '') {
		// 	setSearchText('')
		val = validateVal(val);
		window.location.href = `/search?q=${encodeURIComponent(val.replace(/%/g, "~percent~"))}`
		setSearchAction(!searchAction)
		//}
	}

	function setPropsLanguage() {
		setLanguage(language === 'Ru' ? 'En' : 'Ru')
		localStorage.setItem('language', language === 'Ru' ? 'En' : 'Ru')
		// window.location.reload()
	}

	const filteredsearch = (arr, value) => {
		if (!utils.hasProperty(value)) {
			return []
		}
		let array = arr.filter(el => el.searchValue.toLowerCase().trim().indexOf(value.toLowerCase().trim()) > -1).sort((a, b) => { return b.relev - a.relev }).slice(0, 6);
		//console.log(array)
		return array
	}
	const textInput = useRef(null);

	const RenderRubbles = () => (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
			<path d="M10.125 2.25H5.25V9H3.75V10.5H5.25V12H3.75V13.5H5.25V15.75H6.75V13.5H9.75V12H6.75V10.5H10.125C12.405 10.5 14.25 8.655 14.25 6.375C14.25 4.095 12.405 2.25 10.125 2.25ZM10.125 9H6.75V3.75H10.125C11.5725 3.75 12.75 4.9275 12.75 6.375C12.75 7.8225 11.5725 9 10.125 9Z" fill="#8987A2" />
		</svg>

	)

	const getCurrencyTitle = (currency) => {
		let cur = language === 'Ru' ? 'Валюта' : 'Currency';
		let cur_ = language === 'Ru' ? 'y.e.' : 'c.u.'
		if (currency !== '1') {
			cur_ = language === 'Ru' ? 'руб.' : 'rub.';
		}
		return `${cur} ${cur_}`
	}

	const renderCurrency = () => {
		let currency = props.userCollection.CatalogCu || props.userCollection.inCu;
		let currYE_ = language === 'Ru' ? 'y.e.' : 'c.u.'

		return (
			<Tooltip title={getCurrencyTitle(currency)}>
				{
					!!props.userCollection.CatalogCu
						?
						<span className={classes.lang} style={{ fontSize: currency !== '1' ? '18px' : undefined, cursor: 'not-allowed' }} >{currency !== '1' ? "₽" : currYE_}</span>
						:
						<Link className={classes.lang} href={searchParams.has("RUB") ? window.location.replace(window.location.pathname) : ''} style={{ fontSize: currency !== '1' ? '18px' : undefined }} onClick={props.userCollection.setCurrency}>{currency !== '1' ? "₽" : currYE_}</Link>
				}
			</Tooltip>
		)
	}


	return (
		<div className={classes.root}>
			<AppBar
				position="fixed"
				className={clsx(classes.appBar, {
					[classes.appBarShift]: props.open
				})}
			>
				<Toolbar className={classes.toolBar}>
					<IconButton
						edge="start"
						// className={classes.menuButton}
						className={clsx(classes.menuButton, {
							[classes.sectionMenuButtonHide]: searchFocus === true
						})}
						color="inherit"
						aria-label="open drawer"
						onClick={props.handleDrawer}
					>
						<MenuIcon fill={'#C4C4C4'} />
					</IconButton>

					<Grid item className={classes.containerLogo}>
						{language === 'Ru' ?
							<Link href="https://www.cft.ru/" target="_blank" >
								<svg width="140" height="48" viewBox="0 0 140 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd" d="M0 48H140V0H0V48Z" fill="#D82335" />
									<path fillRule="evenodd" clipRule="evenodd" d="M128.493 33.525V29.25H127.709L125.629 31.968V29.25H124.724V33.525H125.508L127.588 30.808V33.525H128.493ZM126.593 28.181C126.383 28.181 126.232 28.029 126.232 27.815H125.629C125.629 28.365 126.021 28.762 126.594 28.762C127.166 28.762 127.559 28.365 127.559 27.815H126.955C126.955 28.029 126.805 28.181 126.594 28.181H126.593ZM123.453 33.525V29.25H122.669L120.589 31.968V29.25H119.684V33.525H120.468L122.548 30.808V33.525H123.453ZM116.031 33.525H116.936V30.075H118.896V29.25H116.031V33.525ZM110.566 31.388C110.566 32.609 111.561 33.617 112.858 33.617C114.155 33.617 115.149 32.609 115.149 31.387C115.149 30.167 114.155 29.158 112.858 29.158C111.561 29.158 110.566 30.166 110.566 31.388ZM111.501 31.388C111.501 30.594 112.104 29.983 112.858 29.983C113.612 29.983 114.215 30.594 114.215 31.388C114.215 32.181 113.612 32.792 112.858 32.792C112.104 32.792 111.501 32.182 111.501 31.388ZM109.685 29.25H106.64V30.57C106.64 32.395 106.338 32.7 105.916 32.7C105.765 32.7 105.614 32.64 105.614 32.64V33.513C105.614 33.513 105.855 33.617 106.157 33.617C106.971 33.617 107.544 33.037 107.544 30.563V30.075H108.78V33.525H109.685V29.25ZM100.692 31.388C100.692 32.609 101.687 33.617 102.984 33.617C104.281 33.617 105.275 32.609 105.275 31.387C105.275 30.167 104.281 29.158 102.984 29.158C101.687 29.158 100.692 30.166 100.692 31.388ZM101.627 31.388C101.627 30.594 102.23 29.983 102.984 29.983C103.738 29.983 104.341 30.594 104.341 31.388C104.341 32.181 103.738 32.792 102.984 32.792C102.23 32.792 101.627 32.182 101.627 31.388ZM99.811 29.25H98.906V30.96H97.097V29.25H96.192V33.525H97.097V31.785H98.907V33.525H99.811V29.25ZM93.354 31.968L94.379 33.525H95.404L93.927 31.296L95.284 29.25H94.258L93.354 30.624L92.449 29.25H91.424L92.781 31.296L91.303 33.525H92.328L93.354 31.968ZM88.494 32.701V31.754H90.214V30.93H88.494V30.075H90.696V29.25H87.59V33.525H90.756V32.701H88.494ZM83.424 29.251V30.075H84.631V33.525H85.535V30.075H86.741V29.25H83.425L83.424 29.251ZM130.275 24.123L131.302 25.777H132.329L130.849 23.409L132.208 21.235H131.181L130.275 22.695L129.37 21.235H128.343L129.702 23.409L128.222 25.777H129.249L130.275 24.123ZM123.718 24.901V23.604H124.503C124.866 23.604 125.138 23.895 125.138 24.252C125.138 24.609 124.865 24.902 124.503 24.902H123.718V24.901ZM124.534 25.777C125.409 25.777 126.044 25.109 126.044 24.252C126.044 23.389 125.409 22.727 124.534 22.727H123.718V21.235H122.812V25.777H124.534ZM126.526 25.777H127.433V21.235H126.526V25.777ZM120.181 22.046C120.482 22.046 120.664 22.24 120.664 22.533C120.664 22.825 120.482 23.019 120.181 23.019H119.335V22.046H120.181ZM119.335 24.966V23.798H120.301C120.633 23.798 120.875 24.058 120.875 24.382C120.875 24.706 120.633 24.966 120.301 24.966H119.335ZM120.344 25.777C121.207 25.777 121.781 25.148 121.781 24.447C121.781 23.668 121.086 23.376 121.086 23.376C121.086 23.376 121.569 23.084 121.569 22.436C121.569 21.819 121.026 21.235 120.241 21.235H118.429V25.777H120.344ZM112.956 23.506C112.956 24.804 113.953 25.875 115.251 25.875C116.55 25.875 117.546 24.804 117.546 23.505C117.546 22.208 116.55 21.138 115.251 21.138C113.953 21.138 112.956 22.208 112.956 23.506ZM113.892 23.506C113.892 22.662 114.496 22.013 115.252 22.013C116.006 22.013 116.61 22.663 116.61 23.506C116.61 24.35 116.006 24.999 115.251 24.999C114.496 24.999 113.892 24.349 113.892 23.506ZM110.655 21.138C109.355 21.138 108.36 22.208 108.36 23.506C108.36 24.804 109.356 25.875 110.655 25.875C111.832 25.875 112.436 24.966 112.436 24.966L111.892 24.35C111.892 24.35 111.47 24.999 110.655 24.999C109.869 24.999 109.265 24.349 109.265 23.506C109.265 22.662 109.869 22.013 110.655 22.013C111.44 22.013 111.832 22.663 111.832 22.663L112.406 22.046C112.406 22.046 111.832 21.138 110.655 21.138ZM107.328 21.235H106.423V23.052H104.611V21.235H103.705V25.777H104.611V23.927H106.423V25.777H107.328V21.235ZM101.586 24.706L101.949 25.777H102.915L101.255 21.235H100.288L98.628 25.777H99.594L99.956 24.707H101.586V24.706ZM101.285 23.863H100.258L100.771 22.37L101.285 23.863ZM97.837 21.235H96.932V23.052H95.12V21.235H94.214V25.777H95.12V23.927H96.932V25.777H97.837V21.235ZM92.941 25.777V21.235H92.156L90.073 24.123V21.235H89.166V25.777H89.952L92.035 22.889V25.777H92.941ZM87.29 23.441C87.29 24.025 86.897 24.447 86.263 24.479V22.403C86.897 22.435 87.29 22.857 87.29 23.441ZM86.263 25.323C87.411 25.291 88.196 24.447 88.196 23.441C88.196 22.435 87.411 21.591 86.263 21.559V21.072H85.357V21.559C84.21 21.591 83.425 22.435 83.425 23.441C83.425 24.447 84.21 25.291 85.357 25.323V25.907H86.263V25.323ZM84.331 23.441C84.331 22.857 84.723 22.435 85.357 22.403V24.479C84.723 24.447 84.331 24.025 84.331 23.441ZM102.978 15.05C103.341 15.05 103.613 15.307 103.613 15.622C103.613 15.937 103.341 16.195 102.978 16.195H102.131V15.05H102.978ZM101.224 14.278V18.283H102.131V16.967H103.008C103.885 16.967 104.521 16.383 104.521 15.622C104.521 14.867 103.885 14.278 103.008 14.278H101.224ZM97.047 14.278V15.05H98.257V18.283H99.163V15.05H100.373V14.278H97.047ZM96.195 14.278H95.288V15.88H93.473V14.278H92.566V18.283H93.473V16.653H95.288V18.283H96.195V14.278ZM89.265 17.51V16.624H90.989V15.851H89.265V15.051H91.473V14.278H88.358V18.283H91.533V17.51H89.265ZM83.425 18.283H86.569V19.113H87.477V17.51H86.963V14.278H86.056V17.51H84.332V14.278H83.425V18.283ZM43.603 33.617H48.453V32.177C53.576 32.177 57.534 29.432 57.534 24.071C57.534 18.766 53.537 15.965 48.452 15.965V14.278H43.602V15.965C38.476 15.965 34.521 18.705 34.521 24.071C34.521 29.399 38.501 32.177 43.603 32.177V33.617ZM48.453 28.244V19.899C51.135 19.899 53.021 21.29 53.021 24.071C53.021 26.881 51.158 28.244 48.452 28.244H48.453ZM39.005 24.071C39.005 21.29 40.927 19.899 43.603 19.899V28.244C40.904 28.244 39.005 26.881 39.005 24.071ZM75.753 14.278H59.452V18.587H65.115V33.617H70.062V18.587H75.753V14.278ZM24.859 29.937H18.324V14.278H13.425V34.391H27.514V36.518H31.969L32.603 29.937H29.787V14.278H24.859V29.937Z" fill="#FFFFFE" />
								</svg>
							</Link>
							:
							<Link href="https://www.cft.ru/En" target="_blank">
								<svg width="140" height="48" viewBox="0 0 140 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="140" height="48" fill="white" />
									<path fillRule="evenodd" clipRule="evenodd" d="M0 48H140V0H0V48Z" fill="#D82335" />
									<path fillRule="evenodd" clipRule="evenodd" d="M128.014 32.3405C128.014 32.6494 127.767 32.8958 127.305 32.8958C126.658 32.8958 126.288 32.4325 126.288 32.4325L125.733 32.9884C125.733 32.9884 126.288 33.6967 127.367 33.6967C128.415 33.6967 129 33.1113 129 32.3405C129 30.7998 126.873 31.2617 126.873 30.46C126.873 30.2136 127.089 29.9974 127.459 29.9974C127.952 29.9974 128.261 30.3681 128.261 30.3681L128.815 29.7819C128.815 29.7819 128.353 29.1965 127.397 29.1965C126.472 29.1965 125.888 29.7819 125.888 30.4607C125.888 32.0015 128.014 31.5389 128.014 32.3405ZM122.769 32.7716V31.8169H124.526V30.9844H122.769V30.121H125.02V29.2892H121.844V33.6041H125.081V32.7716H122.769ZM119.621 33.6041H120.545V29.2892H119.621V33.6041ZM116.718 31.2617V31.9397H117.49V32.5259C117.49 32.5259 117.181 32.8642 116.534 32.8642C115.733 32.8642 115.116 32.2479 115.116 31.447C115.116 30.6453 115.733 30.029 116.534 30.029C117.335 30.029 117.736 30.6453 117.736 30.6453L118.322 30.0599C118.322 30.0599 117.736 29.1965 116.534 29.1965C115.209 29.1965 114.191 30.2136 114.191 31.447C114.191 32.6796 115.208 33.6967 116.534 33.6967C117.767 33.6967 118.414 32.8642 118.414 32.8642V31.2617H116.719H116.718ZM108.701 31.447C108.701 32.6796 109.717 33.6967 111.042 33.6967C112.368 33.6967 113.385 32.6796 113.385 31.447C113.385 30.2136 112.368 29.1965 111.042 29.1965C109.718 29.1965 108.701 30.2136 108.701 31.447ZM109.656 31.447C109.656 30.6453 110.272 30.029 111.042 30.029C111.813 30.029 112.429 30.6453 112.429 31.447C112.429 32.2479 111.813 32.8642 111.043 32.8642C110.272 32.8642 109.656 32.2479 109.656 31.447ZM108.447 33.6041V32.7716H106.443V29.2892H105.518V33.6041H108.447ZM99.9322 31.447C99.9322 32.6796 100.949 33.6967 102.275 33.6967C103.6 33.6967 104.618 32.6796 104.618 31.447C104.618 30.2136 103.6 29.1965 102.275 29.1965C100.95 29.1965 99.9322 30.2136 99.9322 31.447ZM100.888 31.447C100.888 30.6453 101.504 30.029 102.275 30.029C103.045 30.029 103.661 30.6453 103.661 31.447C103.661 32.2479 103.045 32.8642 102.275 32.8642C101.504 32.8642 100.888 32.2479 100.888 31.447H100.888ZM98.1066 29.2892V32.0324L95.9797 29.2892H95.1781V33.6041H96.1025V30.8608L98.2301 33.6041H99.0311V29.2892H98.1066ZM93.8789 29.2892H92.9544V31.0153H91.1047V29.2892H90.1803V33.6041H91.1047V31.8471H92.9544V33.6041H93.8795V29.2892H93.8789ZM87.4322 29.1965C86.1076 29.1965 85.0898 30.2136 85.0898 31.447C85.0898 32.6796 86.1069 33.6967 87.4322 33.6967C88.6347 33.6967 89.251 32.8333 89.251 32.8333L88.6964 32.2479C88.6964 32.2479 88.2641 32.8642 87.4322 32.8642C86.6313 32.8642 86.015 32.2479 86.015 31.447C86.015 30.6453 86.6313 30.029 87.4322 30.029C88.2345 30.029 88.6347 30.6453 88.6347 30.6453L89.2208 30.0599C89.2208 30.0599 88.6347 29.1965 87.4322 29.1965ZM81.9725 32.7722V31.8169H83.7295V30.9844H81.9725V30.121H84.2223V29.2892H81.0474V33.6041H84.2841V32.7716H81.9725V32.7722ZM76.7894 29.2892V30.121H78.0228V33.6041H78.9472V30.121H80.1799V29.2892H76.7894ZM123.69 25.7059V24.8747H121.686V21.391H120.761V25.7066H123.69V25.7059ZM118.599 24.6887L118.969 25.7059H119.955L118.26 21.3903H117.274L115.578 25.7059H116.565L116.934 24.6887H118.599ZM118.291 23.8878H117.243L117.767 22.4692L118.291 23.8878ZM113.848 25.7066H114.773V21.3903H113.848V25.7059V25.7066ZM111.1 21.2983C109.775 21.2983 108.757 22.3154 108.757 23.5488C108.757 24.7814 109.775 25.7985 111.1 25.7985C112.302 25.7985 112.919 24.9351 112.919 24.9351L112.364 24.3497C112.364 24.3497 111.932 24.966 111.1 24.966C110.298 24.966 109.682 24.3497 109.682 23.5488C109.682 22.7471 110.298 22.1301 111.1 22.1301C111.902 22.1301 112.302 22.7471 112.302 22.7471L112.888 22.161C112.888 22.161 112.302 21.2983 111.1 21.2983ZM106.78 21.3903V24.1342L104.653 21.3903H103.852V25.7059H104.777V22.9626L106.903 25.7059H107.705V21.3903H106.78ZM101.69 24.6887L102.06 25.7059H103.046L101.351 21.3903H100.365L98.6694 25.7059H99.6556L100.026 24.6887H101.69ZM101.382 23.8878H100.334L100.858 22.4692L101.382 23.8878ZM96.9385 21.3903V24.1342L94.8116 21.3903H94.0106V25.7059H94.9351V22.9626L97.0627 25.7059H97.863V21.3903H96.9385ZM91.7869 25.7059H92.7114V21.3903H91.7869V25.7059ZM87.621 21.3903V25.7059H88.5455V24.0107H90.3024V23.1795H88.5455V22.2242H90.7959V21.391H87.621V21.3903ZM82.2244 21.3903V25.7059H83.1489V24.0107H84.9059V23.1795H83.1489V22.2242H85.3993V21.391H82.2244V21.3903ZM76.4868 23.5488C76.4868 24.7814 77.5032 25.7985 78.8285 25.7985C80.1545 25.7985 81.1716 24.7814 81.1716 23.5488C81.1716 22.3154 80.1545 21.2976 78.8285 21.2976C77.5039 21.2976 76.4868 22.3154 76.4868 23.5488ZM77.4421 23.5488C77.4421 22.7471 78.0584 22.1301 78.8285 22.1301C79.5992 22.1301 80.2162 22.7471 80.2162 23.5488C80.2162 24.3497 79.5992 24.966 78.8285 24.966C78.0584 24.966 77.4421 24.3497 77.4421 23.5488ZM101.599 14.9128C101.599 15.2216 101.352 15.468 101.014 15.468H100.058V14.3273H101.014C101.353 14.3273 101.599 14.5744 101.599 14.9128ZM99.1333 17.8104H100.058V16.3005H100.859L101.692 17.8104H102.678L101.754 16.177C101.754 16.177 102.524 15.8379 102.524 14.9128C102.524 14.1235 101.908 13.4948 101.045 13.4948H99.1333V17.8104ZM95.769 16.9779V16.0226H97.526V15.1901H95.769V14.3273H98.0194V13.4948H94.8445V17.8104H98.0812V16.9779H95.7683H95.769ZM90.5866 13.4948V14.3273H91.8192V17.8104H92.7437V14.3273H93.977V13.4948H90.5866ZM88.7939 13.4948V16.2388L86.6677 13.4948H85.8661V17.8104H86.7905V15.0672L88.9174 17.8104H89.7191V13.4955H88.7939V13.4948ZM82.5017 16.9779V16.0226H84.2587V15.1901H82.5017V14.3273H84.7515V13.4948H81.5765V17.8104H84.8132V16.9779H82.5017ZM78.8285 13.4022C77.5039 13.4022 76.4868 14.4193 76.4868 15.6526C76.4868 16.8853 77.5032 17.9031 78.8285 17.9031C80.0316 17.9031 80.6473 17.0397 80.6473 17.0397L80.0927 16.4543C80.0927 16.4543 79.6603 17.0706 78.8285 17.0706C78.0276 17.0706 77.4112 16.4543 77.4112 15.6526C77.4112 14.8517 78.0276 14.2347 78.8285 14.2347C79.6308 14.2347 80.0316 14.8517 80.0316 14.8517L80.6171 14.2656C80.6171 14.2656 80.0316 13.4029 78.8285 13.4029V13.4022ZM21.6895 13C24.4258 13 27.3338 13.9128 29.3282 15.8791L27.0201 19.6422C25.7093 18.5016 23.7423 17.5613 21.9173 17.5613C17.8406 17.5613 16.1591 20.4404 16.1591 23.3765C16.1591 26.3977 17.984 29.5054 21.9173 29.5054C23.942 29.5054 25.9371 28.3935 27.3338 26.9962L29.8992 30.6453C28.1031 32.4984 25.4244 34.066 21.6895 34.066C15.1337 34.066 11 29.5335 11 23.4897C11 17.5613 15.3897 13 21.6895 13ZM48.4752 13.4942V17.9751H38.2923V22.1789H47.4622V26.6606H38.293V33.602H33.3137V13.4942H48.4745H48.4752ZM67.951 13.4942V17.9751H62.212V33.6027H57.2231V17.9751H51.5129V13.4935H67.951V13.4942Z" fill="#FFFFFE" />
								</svg>
							</Link>
						}
					</Grid>

					<Grid item className={classes.titleContainer}>
						<Link href="https://catalog.cft.ru/" className={classes.title} underline='none'>
							{translate.TopMenu[`Top1${language}`]} <br /> {translate.TopMenu[`Top2${language}`]}
						</Link>
					</Grid>

					<Grid item style={{ flexGrow: 1 }} />

					{window.location.href.includes('search') ? '' :
						<Grid item
							key={props.ml}
							className={classes.search}
						>
							<CustomAutocomplete
								ref={textInput}
								onChange={(e, value) => setSearchText(value)}
								label={translate.Words[`SearchGlobal${language}`]}
								// label={window.innerWidth < 440 ? translate.Words[`SearchGlobalCut${language}`] : translate.Words[`SearchGlobal${language}`]}
								onFocus={(e) => setSearchFocus(true)}
								onKeyDown={(val) => handleKeyDown(val)}
								value={searchText}
								options={filteredsearch(searchPhrases, searchText).map((option) => option.searchValue)}
							/>


							{/* при нажатии на SearchIcon меняем на крестик */}
							<IconButton className={classes.searchIcon} style={{ zIndex: searchFocus === true ? 20 : 2 }} onClick={searchText !== '' ? (e) => searchClick(e, searchText) : (e) => setSearchFocus(true) /* (e) => handleKeyDown(e, e.target.value) */}>
								<SearchIcon fill={'#BCBBD0'} />
							</IconButton>
						</Grid>
					}
					<Grid item className={classes.grow} />

					<IconButton aria-label="add to favorites"
						onClick={(e) => setSearchFocus(false)}

						className={clsx(classes.inputCloseBtn, {
							[classes.inputCloseBtnHide]: searchFocus === false
						})}
					>
						<CloseIcon fill={'#BCBBD0'} />
					</IconButton>

					<Grid
						item
						container
						id='a155'
						direction="row"
						justify="flex-end"
						alignItems="center"
						className={classes.sectionDesktop}
					// className={clsx(classes.sectionDesktop, {
					// 	[classes.sectionDesktopHide]: searchFocus === true
					// })}
					>
						<Grid item /*style={{ paddingRight: 8 }}*/>
							<IconBtn href={`/favorites`} size='normal1' icon={12} badge={props.userCollection.appFavorite && props.userCollection.appFavorite.length > 0 || props.userCollection.productFavorite && props.userCollection.productFavorite.length > 0} />
						</Grid>

						<Grid item style={{ paddingRight: 8 }}>
							<IconBtn href={`/cart`} icon={6} size='normal2' badge={props.userCollection.appBasket && props.userCollection.appBasket.length > 0 || props.userCollection.productBasket && props.userCollection.productBasket.length > 0} />
						</Grid>

						<Grid item>
							<Autorization
								// usname={username}
								lang={language}
								usname={usname}
								setUsname={setUsname}
								isAuth={isAuth}
								setIsAuth={setIsAuth}
								kloUser={kloUser}
								_kloUser={_kloUser} />
						</Grid>

						<Grid item className={classes.currencyContainer}>
							{renderCurrency()}
							{/* {window.location.href.indexOf('//catalog.cft.ru/') === -1 ? <Link className={classes.lang} href='' onClick={setPropsLanguage}>{language === 'Ru' ? "En" : "Ru"}</Link> : null} */}
						</Grid>

						{/* ПЕРЕКЛЮЧАТЕЛЬ ЯЗЫКА  Теперь работает везде кроме бою, определяет по ссылке*/}
						<Grid item className={classes.langContainer} >
							<Link className={classes.lang} href='' onClick={setPropsLanguage}>{language === 'Ru' ? "En" : "Ru"}</Link>
							{/* {window.location.href.indexOf('//catalog.cft.ru/') === -1 ? <Link className={classes.lang} href='' onClick={setPropsLanguage}>{language === 'Ru' ? "En" : "Ru"}</Link> : null} */}
						</Grid>

					</Grid>

				</Toolbar>

				{window.location.pathname.indexOf('/search') === -1 ?
					<Grid container direction='row' className={classes.searchContainer}>
						<Grid container direction='row'
							key={props.ml}
							className={classes.search2}
						>
							{/* <InputBase
									placeholder={translate.Words[`SearchGlobal${language}`]}
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput 
									}}
									inputProps={{ 'aria-label': 'search' }}
									onFocus={(e) => setSearchFocus(true)}
									value={searchText}
									onChange={(e) => setSearchText(e.target.value)}
									onKeyDown={(e) => handleKeyDown(e, e.target.value)}
								/> */}
							<CustomAutocomplete
								ref={textInput}
								onChange={(e, value) => setSearchText(value)}
								label={translate.Words[`SearchGlobal${language}`]}
								// label={window.innerWidth < 440 ? translate.Words[`SearchGlobalCut${language}`] : translate.Words[`SearchGlobal${language}`]}
								onFocus={(e) => setSearchFocus(true)}
								onKeyDown={(val) => handleKeyDown(val)}
								value={searchText}
								options={filteredsearch(searchPhrases, searchText).map((option) => option.searchValue)}
							/>


							{/* при нажатии на SearchIcon меняем на крестик */}
							<IconButton className={classes.searchIcon} style={{ zIndex: searchFocus === true ? 20 : 2 }} onClick={searchText !== '' ? (e) => searchClick(e, searchText) : (e) => setSearchFocus(true) /* (e) => handleKeyDown(e, e.target.value) */}>
								<SearchIcon fill={'#BCBBD0'} />
							</IconButton>
						</Grid>
					</Grid>
					: null
				}
			</AppBar>
		</div>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,

		[theme.breakpoints.down(1366)]: {
			flexGrow: 0,
		}
	},

	appBar: {
		width: `calc(100% - ${drawerWidthMin}px)`,
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),

		[theme.breakpoints.down(1366)]: {
			width: '100%',
			transition: 'none',
		},

		boxShadow: 'none'
	},

	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		[theme.breakpoints.down(1366)]: {
			marginLeft: 0,
			transition: 'none',
			width: '100%'
		}
	},

	toolBar: {
		minHeight: 96,
		paddingRight: 17
	},

	containerLogo: {
		width: 140,
		height: 48,
		[theme.breakpoints.down(696)]: {
			display: 'none'
		}
	},

	menuButton: {
		marginRight: 11,
		[theme.breakpoints.up(1366)]: {
			display: "none"
		}
	},

	sectionMenuButtonHide: {
		width: 48,
		minWidth: 48,
		maxWidth: 48,
		marginRight: theme.spacing(2),
		[theme.breakpoints.down(695)]: {
			display: 'none'
		}
	},

	searchButton: {
		[theme.breakpoints.up(1032)]: {
			display: "none"
		}
	},

	titleContainer: {
		width: 160,
		[theme.breakpoints.down(862)]: {
			display: 'none'
		}
		// flexGrow: 1,
	},

	title: {
		display: 'block',
		fontWeight: 500,
		fontSize: 14,
		lineHeight: '18px',
		paddingTop: 0,
		paddingBottom: 0,
		flexGrow: 1,
		[theme.breakpoints.down(696)]: {
			display: 'none',
		},

		padding: theme.spacing(2),
		color: '#000000',
		minWidth: 160,
	},

	hideSearch: {
		position: 'relative',
		borderRadius: 24,
		backgroundColor: '#EEEEF5',
		// '&:hover': {
		// 	backgroundColor: fade(theme.palette.common.white, 0.25),
		// },
		marginLeft: 0,
		marginRight: theme.spacing(1),
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(1),
			width: 'auto',
		},

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	searchIcon: {
		padding: theme.spacing(0, 1.5),
		height: '100%',
		position: 'absolute',
		// pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#8987A2',
		right: 0,
		top: 0,
		cursor: 'pointer',

		[theme.breakpoints.down(1032)]: {
			background: '#F7F6FB',
			zIndex: 10,

			'&:hover': {
				background: '#F7F6FB'
			}
		}
	},

	inputRoot: {
		color: '#8987A2',
		float: 'right',
		[theme.breakpoints.down(1032)]: {
			backgroundColor: 'transparent',
			width: '100%',
			float: 'right',
			zIndex: 11
		},

		'&:focus': {
			zIndex: 4
		}
	},

	inputInput: {
		padding: theme.spacing(1, 2),
		// vertical padding + font size from searchIcon
		paddingRight: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create('width'),
		width: 232,
		height: 32,
		[theme.breakpoints.down(1032)]: {
			width: 0,
			zIndex: 11,

			'&:focus': {
				width: 207,

				[theme.breakpoints.down('md')]: {
					width: '100%',
					zIndex: 4
				}
			},
		},
		color: '#8987A2'
	},

	search: {
		position: 'relative',
		borderRadius: 24,
		backgroundColor: '#EEEEF5',
		// '&:hover': {
		// 	backgroundColor: fade(theme.palette.common.white, 0.25),
		// },
		marginLeft: 0,
		marginRight: theme.spacing(1),
		// width: '100%',
		width: 'auto',
		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(1),
			width: 'auto',
		},

		[theme.breakpoints.down(1032)]: {
			backgroundColor: 'transparent',
			width: '100%'
		},
		[theme.breakpoints.between(696, 800)]: {
			width: 'calc(100% - 454px)'
		},
		[theme.breakpoints.between(861, 926)]: {
			width: 'calc(100% - 613px)'
		},
		[theme.breakpoints.down(441)]: {
			display: 'none'
		},

	},

	searchContainer: {
		height: 64,

		[theme.breakpoints.up(441)]: {
			display: 'none'
		},
	},

	search2: {
		position: 'relative',
		borderRadius: 24,
		backgroundColor: '#EEEEF5',
		marginLeft: 17,
		marginRight: 16,
		height: 48,
		// '&:hover': {
		// 	backgroundColor: fade(theme.palette.common.white, 0.25),
		// },
		//marginLeft: 0,
		marginRight: theme.spacing(1),
		// width: '100%',
		// width: 'auto',
		// [theme.breakpoints.up('sm')]: {
		// 	marginLeft: theme.spacing(1),
		// 	width: 'auto',
		// },
	},

	inputCloseBtn: {
		display: 'block',

		[theme.breakpoints.up(1032)]: {
			display: 'none'
		}
	},

	inputCloseBtnHide: {
		display: 'none'
	},

	sectionDesktop: {
		// width: 216,
		// minWidth: 216,
		// maxWidth: 216,
		width: 260,
		minWidth: 260,
		maxWidth: 260,
		display: 'flex'
	},

	sectionDesktopHide: {
		// width: 213,
		// minWidth: 213,
		// maxWidth: 213,
		width: 155,
		minWidth: 155,
		maxWidth: 155,
		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	lang: {
		fontSize: 16,
		color: '#8987A2',
		textDecoration: 'none',
		lineHeight: '18px',
		cursor: 'pointer'
	},
	currencyContainer: {
		paddingLeft: 16,
		width: 35,
		[theme.breakpoints.down(440)]: {
			paddingLeft: 12,
			width: 'auto'
		},
	},
	langContainer: {
		paddingLeft: 16,
		width: 35,
		[theme.breakpoints.down(440)]: {
			paddingLeft: 12,
			width: 'auto',
			paddingRight: 8
		},
	},
}));

